class SPdpClips extends HTMLElement {
  #ac;
  #io;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const rail = this.querySelector('.pc-rail');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = [...this.querySelectorAll('video[data-pc-video]')];

    this.addEventListener('click', this.#onClick, opts);
    rail?.addEventListener('scroll', this.#syncNav, { ...opts, passive: true });
    window.addEventListener('resize', this.#syncNav, opts);
    this.#syncNav();

    if (!videos.length) return;
    videos.forEach((v) => {
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    this.#io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          const v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            v.preload = 'auto';
            v.play?.().catch(() => {});
          } else {
            v.pause?.();
          }
        }
      },
      { threshold: [0, 0.6, 1] }
    );
    videos.forEach((v) => this.#io.observe(v));
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#io?.disconnect();
  }

  #syncNav = () => {
    const rail = this.querySelector('.pc-rail');
    if (!rail) return;
    const max = rail.scrollWidth - rail.clientWidth - 2;
    const prev = this.querySelector('[data-pc-prev]');
    const next = this.querySelector('[data-pc-next]');
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
    this.toggleAttribute('data-overflow', max > 0);
  };

  #onClick = (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    const rail = this.querySelector('.pc-rail');
    if (t.closest('[data-pc-prev]') || t.closest('[data-pc-next]')) {
      const dir = t.closest('[data-pc-next]') ? 1 : -1;
      const card = rail?.querySelector('.pc');
      const step = card ? card.getBoundingClientRect().width + 20 : 320;
      rail?.scrollBy({ left: dir * step * 1.5, behavior: 'smooth' });
      return;
    }
    const sound = t.closest('[data-pc-sound]');
    if (sound) {
      const video = sound.closest('.pc')?.querySelector('video');
      if (!video) return;
      const on = video.muted;
      this.querySelectorAll('video[data-pc-video]').forEach((v) => (v.muted = true));
      this.querySelectorAll('[data-pc-sound]').forEach((b) => {
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', b.dataset.labelOff || '');
      });
      if (on) {
        video.muted = false;
        sound.setAttribute('aria-pressed', 'true');
        sound.setAttribute('aria-label', sound.dataset.labelOn || '');
        video.play?.().catch(() => {});
      }
      return;
    }
    const frame = t.closest('.pc-frame');
    const video = frame?.querySelector('video');
    if (video) video.paused ? video.play?.().catch(() => {}) : video.pause?.();
  };
}

if (!customElements.get('s-pdp-clips')) customElements.define('s-pdp-clips', SPdpClips);
